export default __webpack_public_path__ + "static/media/poppiestill.30cb31b2.png";